import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import replace from 'lodash/replace';
import includes from 'lodash/includes';
import { Interweave } from 'interweave';
import ContextProvider from '../../../context';
import CustomModal from '../../../components/Modals/Modal';
import SkillEvaluationForm from './SkillEvaluationForm';
import s from './SkillEvaluationModal.scss';
import history from '../../../history';

const messages = defineMessages({
  saveLabel: {
    id: 'General.saveLabel',
    defaultMessage: 'Save',
  },
});

const SkillEvaluationModal = ({ isOpen, onSave, courseId }) => {
  const { fetch } = useContext(ContextProvider);
  const [skillLevel, setSkillLevel] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbarError, setSnackbarError] = useState('');

  const onSkillLevelSave = () => {
    setIsSubmitting(true);
    return fetch('/api/user_skills', {
      method: 'POST',
      body: JSON.stringify({ skillLevel, courseId }),
    })
      .then(res => {
        const query = history.location.search;
        if (includes(query, 'showEvaluationModal')) {
          history.replace({
            search: replace(query, 'showEvaluationModal', ''),
          });
        }
        if (!res.ok) {
          return res.json().then(err => {
            if (err.message && res.status === 412) {
              return setSnackbarError(err.message);
            }
            throw new Error(res.statusText);
          });
        }
        setIsSubmitting(false);
        return onSave();
      })
      .catch(err => {
        setIsSubmitting(false);
        console.error(err);
      });
  };

  const onCloseSnackbar = () => {
    setSnackbarError('');
    return onSave();
  };

  return (
    <CustomModal
      isOpen={isOpen}
      classes={{ paper: s.paper }}
      aria-describedby="course-skill-evaluation-modal"
      data-test="course-skill-evaluation-modal"
    >
      <SkillEvaluationForm
        setSkillLevel={setSkillLevel}
        skillLevel={skillLevel}
      />
      <div className={s.actions}>
        <Button
          data-test-id="Q6VHQxv6e1hrJuQZjffQU"
          fullWidth
          color="primary"
          size="medium"
          variant="outlined"
          onClick={onSkillLevelSave}
          data-test="skill-evaluation-modal-submit-btn"
          disabled={isSubmitting}
        >
          <FormattedMessage {...messages.saveLabel} />
        </Button>
      </div>
      <Snackbar
        open={!!snackbarError}
        autoHideDuration={2000}
        onClose={onCloseSnackbar}
        message={<Interweave content={snackbarError} />}
      />
    </CustomModal>
  );
};

SkillEvaluationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  courseId: PropTypes.string.isRequired,
};

export default injectIntl(withStyles(s)(SkillEvaluationModal));
